module.exports = __webpack_public_path__ + "static/testi-1-4-35b3d64208460fd2dbeda1b1fab26ce7.jpg";